import Vue from 'vue'
import AOS from 'aos'
import 'aos/dist/aos.css'
Vue.use(AOS)
Vue.prototype.aos = AOS.init()

export default ({
});